import { useSearchFilterStore } from '@/entities/map'
import {
  AutoCompleteInput,
  PeriodPicker,
  useSearch,
} from '@/features/room-filter'
import { mapManager } from '@/shared/lib'
import { Button } from '@/shared/ui'

export const SearchBar = () => {
  const filterActions = useSearchFilterStore(state => state.actions)

  const search: Parameters<typeof useSearch>[0]['search'] = ({
    lat,
    lng,
    zoomLevel,
    startDate,
    endDate,
    keyword,
  }) => {
    if (lat && lng) {
      mapManager.changeMapCenter({ lat, lng, zoomLevel })
    }

    filterActions.update({ startDate, endDate })
    filterActions.updateKeyword(keyword)
  }

  const { autoCompleteInputProps, periodPickerProps, handleSubmit } = useSearch(
    { search },
  )

  return (
    <div className="mr-6 flex w-[600px] shrink-0 items-center">
      <div className="flex w-[550px]">
        <AutoCompleteInput
          className="-ml-[11px] w-[300px] shrink-0"
          inputClassName="bg-[rgba(0,0,0,0)] border-none w-full text-[15px]! leading-[22px]! h-[50px] *:placeholder:text-gray-400"
          placeholder="지역, 지하철, 대학교 등을 입력해 주세요"
          popupSideOffset={2}
          {...autoCompleteInputProps}
        />
        <PeriodPicker
          className="h-[50px] w-[265px] shrink-0 focus-visible:outline-none"
          placeholder="일정을 선택해 주세요"
          alignOffset={16}
          sideOffset={2}
          {...periodPickerProps}
        />
      </div>
      <Button
        size="small"
        weight="normal"
        className="w-[50px]"
        onClick={handleSubmit}
      >
        검색
      </Button>
    </div>
  )
}
